/* eslint-disable lingui/no-unlocalized-strings -- categorias e averbadora como vêm do fio (DrawerAddPerson.tsx:75-86) */
import { lazy, Suspense, useState } from 'react';

import type { PersonQuickCreateProps } from './person-quick-create.types';

// Porta do cadastro rápido (P16+) para outros módulos: leve de propósito. O sheet, o formulário e o fio
// só carregam na primeira vez que alguém abre (import dinâmico), para não pesar em quem só importa a porta.

export type { PersonQuickCreateFlow, PersonQuickCreateProps, PersonQuickCreateResult } from './person-quick-create.types';

const PUBLIC_CONSIGNED = 'CONSIGNADO PÚBLICO';
const DEBT_PURCHASE = 'COMPRA DE DÍVIDA';
const BENEFIT_CARD = 'CARTÃO BENEFÍCIO';
const PRIVATE_CONSIGNED = 'CONSIGNADO PRIVADO';

/**
 * "Informações adicionais" obrigatórias na PF (`DrawerAddPerson.tsx:75-86`): categoria especial
 * (consignado, compra de dívida, cartão benefício) ou averbadora `DataprevCreditoTrabalhador`, da
 * operação ou do produto.
 */
export function needsPersonAdditionalInfo(input: {
  readonly categoryName?: string | null | undefined;
  readonly productCategoryName?: string | null | undefined;
  readonly warrantyRegistrationOffice?: string | null | undefined;
  readonly productWarrantyRegistrationOffice?: string | null | undefined;
}): boolean {
  const category = input.categoryName || input.productCategoryName || '';
  const special = [PUBLIC_CONSIGNED, DEBT_PURCHASE, BENEFIT_CARD, PRIVATE_CONSIGNED].includes(category);
  const office = (value: string | null | undefined) => value?.toLowerCase() === 'dataprevcreditotrabalhador';
  return special || office(input.warrantyRegistrationOffice) || office(input.productWarrantyRegistrationOffice);
}

const Sheet = lazy(() => import('./screens/person-quick-create-sheet').then((module) => ({ default: module.PersonQuickCreateSheet })));

/**
 * Cadastro rápido de pessoa física ou jurídica num sheet, sem sair do fluxo (o `DrawerAddPerson` do
 * legado): tipo de cadastro, os passos do legado e o `POST`; devolve a pessoa criada por `onCreated`.
 */
export function PersonQuickCreate(props: PersonQuickCreateProps) {
  const [used, setUsed] = useState(props.open);
  if (props.open && !used) setUsed(true);
  if (!used) return null;
  return (
    <Suspense fallback={null}>
      <Sheet {...props} />
    </Suspense>
  );
}
